// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-complaint-status-dialog p {
  margin-bottom: 0;
}
.customer-complaint-status-dialog .file-load-status {
  color: #337ab7;
  cursor: pointer;
}
.customer-complaint-status-dialog .file-load-status:hover {
  color: #23527c;
}
.customer-complaint-status-dialog .remark-content {
  border: 1px solid #f1f1f1;
  border-radius: 4px;
}
.customer-complaint-status-dialog .remark-content .download_preview {
  border: none;
  float: right;
}
.customer-complaint-status-dialog .remark-content .download_preview .ant-btn {
  padding: 0px 12px;
}
.customer-complaint-status-dialog .remark-content p,
.customer-complaint-status-dialog .remark-content strong {
  padding: 5px 0px;
}
.customer-complaint-status-dialog .remark-content .status {
  float: right;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #777;
  border-radius: 10px;
}
.customer-complaint-status-dialog .remark-content .customer-comment {
  text-align: left !important;
}
.customer-complaint-status-dialog .remark-content .customer-group {
  position: relative;
}
.customer-complaint-status-dialog .remark-content .customer-group .customer-radio-group {
  margin-bottom: 10px;
}
.customer-complaint-status-dialog .remark-content .customer-group .customer-select-group {
  position: absolute;
  top: -11px;
  left: 43%;
}
.customer-complaint-status-dialog .remark-content .customer-reply {
  border: 1px solid #e4e4e4;
  margin: 6px;
  box-sizing: content-box;
}
.customer-complaint-status-dialog .remark-content .customer-reply .reply-fl {
  flex: 1;
}
.customer-complaint-status-dialog .remark-content .customer-reply .reply-fl .reply-status {
  font-style: normal;
  margin-left: 10px;
}
.customer-complaint-status-dialog .remark-content .customer-reply .reply-fl .read {
  color: #bebebe;
}
.customer-complaint-status-dialog .remark-content .customer-reply .reply-fl .unread {
  color: #337ab7;
}
.customer-complaint-status-dialog .remark-content .customer-reply .customer-p1 {
  display: flex;
  border-bottom: 1px dashed #e4e4e4;
  padding: 10px;
  margin-bottom: 5px;
}
.customer-complaint-status-dialog .remark-content .customer-reply .customer-p2 {
  display: flex;
  padding-top: 8px;
  text-indent: 2em;
}
.customer-complaint-status-dialog .remark-content .customer-comment span,
.customer-complaint-status-dialog .remark-content .customer-reply .reply-fr,
.customer-complaint-status-dialog .remark-content .add-remark-btn span {
  display: inline-block;
  cursor: pointer;
}
.customer-complaint-status-dialog .remark-content .add-remark-btn,
.customer-complaint-status-dialog .remark-content .customer-comment,
.customer-complaint-status-dialog .remark-content .reply-fr {
  color: #337ab7;
  font-size: 14px;
  text-align: right;
}
.customer-complaint-status-dialog .remark-content .add-remark-btn:hover,
.customer-complaint-status-dialog .remark-content .customer-comment:hover,
.customer-complaint-status-dialog .remark-content .reply-fr:hover {
  color: #23527c;
}
.customer-complaint-status-dialog .remark-content > ul {
  border-bottom: 1px solid #f1f1f1;
}
.customer-complaint-status-dialog .remark-content > ul > li {
  padding: 10px;
}
.customer-complaint-status-dialog .remark-content > ul > li > ul {
  margin-top: 10px;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
}
.customer-complaint-status-dialog .remark-content > ul > li > ul > li p:first-child {
  border-bottom: 1px solid #f1f1f1;
}
.customer-complaint-status-dialog .remark-content > ul > li > ul > li p {
  padding: 8px 10px;
}
.customer-complaint-status-dialog .remark-content > p {
  padding: 10px;
}
.preview-dialog /deep/ .el-dialog__body {
  margin: 8px 6px 6px;
}
.preview-dialog .width-time,
.preview-dialog .width-installer {
  width: 82px;
}
.preview-dialog .time {
  display: inline-block;
  width: 95px;
}
.preview-dialog .tip {
  display: inline-block;
  width: 120px;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview-dialog ul li {
  border: 1px solid black;
  border-bottom: none;
  height: 50px;
}
.preview-dialog ul li label {
  text-align: center;
  line-height: 50px;
  display: inline-block;
  width: 120px;
  height: 50px;
  border-right: 1px solid black;
  margin-top: -1px;
  vertical-align: middle;
}
.preview-dialog ul li .border-left {
  border-left: 1px solid black;
}
.preview-dialog ul li h3 {
  text-align: center;
  line-height: 50px;
}
.preview-dialog .desc-li,
.preview-dialog .solve-li,
.preview-dialog .battery {
  height: 150px;
}
.preview-dialog .desc-li label,
.preview-dialog .solve-li label,
.preview-dialog .battery label {
  height: 150px;
  line-height: 20px;
}
.preview-dialog .desc-li .red-color {
  padding-top: 50px;
}
.preview-dialog .solve-li .red-color {
  padding-top: 20px;
}
.preview-dialog .desc-li label,
.preview-dialog .solve-li label {
  float: left;
}
.preview-dialog .desc-li span,
.preview-dialog .solve-li span {
  padding-left: 5px;
  width: 520px;
  line-height: 25px;
  padding-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.preview-dialog ul li:nth-child(4) span {
  display: inline-block;
  width: 170px;
}
.preview-dialog ul li:last-child {
  border-bottom: 1px solid black;
}
.preview-dialog .battery {
  border: none;
  border-bottom: 1px solid black;
}
.preview-dialog .battery label {
  line-height: 150px;
  float: left;
  background-color: #ffffff;
  border-left: 1px solid black;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  margin: 0 6px 0 0;
  width: 121px;
}
.preview-dialog .battery ul li span {
  display: inline-block;
  width: 125px;
  padding-top: 1px;
}
.preview-dialog .battery ul li span:first-child {
  text-align: center;
  line-height: 50px;
  border-right: 1px solid black;
}
.preview-dialog .battery ul li span:last-child {
  width: 360px;
  padding: 0 5px;
}
.preview-dialog .battery .type {
  margin-top: -1px;
}
.preview-dialog .battery .quantity {
  height: 49px;
}
.preview-dialog .battery .type,
.preview-dialog .battery .quantity {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview-dialog .ems {
  border-top: none;
  height: 49px;
}
.preview-dialog .red-color {
  color: red;
}
.preview-dialog .remark {
  height: 100px;
}
.preview-dialog .remark label {
  height: 100px;
  float: left;
  line-height: 100px;
}
.preview-dialog .remark span {
  padding-left: 5px;
  width: 520px;
  line-height: 25px;
  padding-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.preview-dialog .solution label,
.preview-dialog .product-model label,
.preview-dialog .dsp label,
.preview-dialog .pv label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview-dialog .battery_model,
.preview-dialog .previewData-number {
  vertical-align: middle;
  margin-top: -40px;
  line-height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ClientList/HistoricalComplaintsDetails/components/ClientStatus/index.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;AAAJ;AAFA;EAKI,cAAA;EACA,eAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AATA;EAcI,yBAAA;EACA,kBAAA;AAFJ;AAbA;EAiBM,YAAA;EACA,YAAA;AADN;AAjBA;EAoBQ,iBAAA;AAAR;AApBA;;EA0BM,gBAAA;AAFN;AAxBA;EA8BM,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AAHN;AAtCA;EA4CM,2BAAA;AAHN;AAzCA;EA+CM,kBAAA;AAHN;AA5CA;EAiDQ,mBAAA;AAFR;AA/CA;EAoDQ,kBAAA;EACA,UAAA;EACA,SAAA;AAFR;AApDA;EA0DM,yBAAA;EACA,WAAA;EACA,uBAAA;AAHN;AAzDA;EA8DQ,OAAA;AAFR;AA5DA;EAgEU,kBAAA;EACA,iBAAA;AADV;AAhEA;EAoEU,cAAA;AADV;AAnEA;EAuEU,cAAA;AADV;AAtEA;EA2EQ,aAAA;EACA,iCAAA;EACA,aAAA;EACA,kBAAA;AAFR;AA5EA;EAiFQ,aAAA;EACA,gBAAA;EACA,gBAAA;AAFR;AAjFA;;;EAyFM,qBAAA;EACA,eAAA;AAHN;AAvFA;;;EA+FM,cAAA;EACA,eAAA;EACA,iBAAA;AAHN;AAKM;;;EACE,cAAA;AADR;AAKI;EACE,gCAAA;AAHN;AAKM;EACE,aAAA;AAHR;AAKQ;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;AAHV;AAKU;EAEI,gCAAA;AAJd;AAEU;EAMI,iBAAA;AALd;AAYI;EACE,aAAA;AAVN;AAcA;EAEI,mBAAA;AAbJ;AAWA;;EAMI,WAAA;AAbJ;AAOA;EASI,qBAAA;EACA,WAAA;AAbJ;AAGA;EAaI,qBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAPA;EAuBI,uBAAA;EACA,mBAAA;EACA,YAAA;AAbJ;AAZA;EA2BM,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,sBAAA;AAZN;AAtBA;EAqCM,4BAAA;AAZN;AAzBA;EAwCM,kBAAA;EACA,iBAAA;AAZN;AA7BA;;;EA+CI,aAAA;AAbJ;AAlCA;;;EAiDM,aAAA;EACA,iBAAA;AAVN;AAxCA;EAsDI,iBAAA;AAXJ;AA3CA;EAyDI,iBAAA;AAXJ;AA9CA;;EA8DM,WAAA;AAZN;AAlDA;;EAiEM,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AAXN;AA9DA;EA6EI,qBAAA;EACA,YAAA;AAZJ;AAlEA;EAiFI,8BAAA;AAZJ;AArEA;EAoFI,YAAA;EACA,8BAAA;AAZJ;AAzEA;EAuFM,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;AAXN;AAnFA;EAkGQ,qBAAA;EACA,YAAA;EAEA,gBAAA;AAbR;AAxFA;EAyGM,kBAAA;EACA,iBAAA;EACA,6BAAA;AAdN;AA7FA;EA8GM,YAAA;EACA,cAAA;AAdN;AAjGA;EAkHM,gBAAA;AAdN;AApGA;EAqHM,YAAA;AAdN;AAvGA;;EAyHM,gBAAA;EACA,uBAAA;EACA,mBAAA;AAdN;AA7GA;EA+HI,gBAAA;EACA,YAAA;AAfJ;AAjHA;EAmII,UAAA;AAfJ;AApHA;EAsII,aAAA;AAfJ;AAvHA;EAwIM,aAAA;EACA,WAAA;EACA,kBAAA;AAdN;AA5HA;EA6IM,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AAdN;AAvIA;;;;EA6JM,gBAAA;EACA,uBAAA;EACA,mBAAA;AAhBN;AA/IA;;EAoKI,sBAAA;EACA,iBAAA;EACA,iBAAA;AAjBJ","sourcesContent":[".customer-complaint-status-dialog {\n  p {\n    margin-bottom: 0;\n  }\n  .file-load-status {\n    color: #337ab7;\n    cursor: pointer;\n\n    &:hover {\n      color: #23527c;\n    }\n  }\n\n  .remark-content {\n    border: 1px solid #f1f1f1;\n    border-radius: 4px;\n    .download_preview {\n      border: none;\n      float: right;\n      .ant-btn {\n        padding: 0px 12px;\n      }\n    }\n\n    p,\n    strong {\n      padding: 5px 0px;\n    }\n\n    .status {\n      float: right;\n      min-width: 10px;\n      padding: 3px 7px;\n      font-size: 12px;\n      font-weight: 700;\n      line-height: 1;\n      color: #fff;\n      text-align: center;\n      white-space: nowrap;\n      vertical-align: middle;\n      background-color: #777;\n      border-radius: 10px;\n    }\n    .customer-comment {\n      text-align: left !important;\n    }\n    .customer-group {\n      position: relative;\n      .customer-radio-group {\n        margin-bottom: 10px;\n      }\n      .customer-select-group {\n        position: absolute;\n        top: -11px;\n        left: 43%;\n      }\n    }\n    .customer-reply {\n      border: 1px solid #e4e4e4;\n      margin: 6px;\n      box-sizing: content-box;\n      .reply-fl {\n        flex: 1;\n        .reply-status {\n          font-style: normal;\n          margin-left: 10px;\n        }\n        .read {\n          color: #bebebe;\n        }\n        .unread {\n          color: #337ab7;\n        }\n      }\n      .customer-p1 {\n        display: flex;\n        border-bottom: 1px dashed #e4e4e4;\n        padding: 10px;\n        margin-bottom: 5px;\n      }\n      .customer-p2 {\n        display: flex;\n        padding-top: 8px;\n        text-indent: 2em;\n      }\n    }\n    .customer-comment span,\n    .customer-reply .reply-fr,\n    .add-remark-btn span {\n      display: inline-block;\n      cursor: pointer;\n    }\n    .add-remark-btn,\n    .customer-comment,\n    .reply-fr {\n      color: #337ab7;\n      font-size: 14px;\n      text-align: right;\n\n      &:hover {\n        color: #23527c;\n      }\n    }\n\n    & > ul {\n      border-bottom: 1px solid #f1f1f1;\n\n      & > li {\n        padding: 10px;\n\n        & > ul {\n          margin-top: 10px;\n          border: 1px solid #f1f1f1;\n          border-radius: 4px;\n\n          & > li {\n            p:first-child {\n              border-bottom: 1px solid #f1f1f1;\n            }\n\n            p {\n              padding: 8px 10px;\n            }\n          }\n        }\n      }\n    }\n\n    & > p {\n      padding: 10px;\n    }\n  }\n}\n.preview-dialog {\n  /deep/ .el-dialog__body {\n    margin: 8px 6px 6px;\n  }\n  .width-time,\n  .width-installer {\n    width: 82px;\n  }\n  .time {\n    display: inline-block;\n    width: 95px;\n  }\n  .tip {\n    display: inline-block;\n    width: 120px;\n    height: 25px;\n    line-height: 25px;\n    vertical-align: middle;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  ul li {\n    border: 1px solid black;\n    border-bottom: none;\n    height: 50px;\n    label {\n      text-align: center;\n      line-height: 50px;\n      display: inline-block;\n      width: 120px;\n      height: 50px;\n      border-right: 1px solid black;\n      margin-top: -1px;\n      vertical-align: middle;\n    }\n    .border-left {\n      border-left: 1px solid black;\n    }\n    h3 {\n      text-align: center;\n      line-height: 50px;\n    }\n  }\n  .desc-li,\n  .solve-li,\n  .battery {\n    height: 150px;\n    label {\n      height: 150px;\n      line-height: 20px;\n    }\n  }\n  .desc-li .red-color {\n    padding-top: 50px;\n  }\n  .solve-li .red-color {\n    padding-top: 20px;\n  }\n  .desc-li,\n  .solve-li {\n    label {\n      float: left;\n    }\n    span {\n      padding-left: 5px;\n      width: 520px;\n      line-height: 25px;\n      padding-top: 10px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 5;\n    }\n  }\n  ul li:nth-child(4) span {\n    display: inline-block;\n    width: 170px;\n  }\n  ul li:last-child {\n    border-bottom: 1px solid black;\n  }\n  .battery {\n    border: none;\n    border-bottom: 1px solid black;\n    label {\n      line-height: 150px;\n      float: left;\n      background-color: #ffffff;\n      border-left: 1px solid black;\n      border-top: 1px solid black;\n      border-bottom: 1px solid black;\n      margin: 0 6px 0 0;\n      width: 121px;\n    }\n    ul li {\n      span {\n        display: inline-block;\n        width: 125px;\n        // height: 50px;\n        padding-top: 1px;\n      }\n    }\n    ul li span:first-child {\n      text-align: center;\n      line-height: 50px;\n      border-right: 1px solid black;\n    }\n    ul li span:last-child {\n      width: 360px;\n      padding: 0 5px;\n    }\n    .type {\n      margin-top: -1px;\n    }\n    .quantity {\n      height: 49px;\n    }\n    .type,\n    .quantity {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n  .ems {\n    border-top: none;\n    height: 49px;\n  }\n  .red-color {\n    color: red;\n  }\n  .remark {\n    height: 100px;\n    label {\n      height: 100px;\n      float: left;\n      line-height: 100px;\n    }\n    span {\n      padding-left: 5px;\n      width: 520px;\n      line-height: 25px;\n      padding-top: 10px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 3;\n    }\n  }\n  .solution,\n  .product-model,\n  .dsp,\n  .pv {\n    label {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n  .battery_model,\n  .previewData-number {\n    vertical-align: middle;\n    margin-top: -40px;\n    line-height: 50px;\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
